{% block acris_faq_document %}
<div class="sw-product-image" :class="faqImageClasses">
    <template v-if="!isPlaceholder">
        {% block acris_faq_document_preview %}
            <sw-media-preview-v2 class="sw-product-image__image"
                              :source="mediaId"
                              :hideTooltip="false">
            </sw-media-preview-v2>
        {% endblock %}
        <sw-context-button class="sw-product-image__context-button" :icon="'regular-pencil-s'">
            {% block acris_faq_document_context %}
                {% block acris_faq_document_context_cover_action %}
                    <sw-context-menu-item @click="$emit('acris-faq-document-edit')">{{ $tc('global.acris-faq-document.context.buttonEdit') }}</sw-context-menu-item>
                {% endblock %}

                {% block acris_faq_document_context_delete_action %}
                    <sw-context-menu-item variant="danger" @click="$emit('acris-faq-document-delete')">{{ $tc('global.sw-product-image.context.buttonRemove') }}</sw-context-menu-item>
                {% endblock %}
            {% endblock %}
        </sw-context-button>
    </template>
    <template v-else class="is--invalid-drag">
        {% block acris_faq_document_placeholder %}
            <mt-icon class="sw-product-image__placeholder-icon" name="regular-image" size="16px"></mt-icon>
        {% endblock %}
    </template>
</div>
{% endblock %}
